<template>
  <div class="c-fancy-progress">
    <div
      class="c-fancy-progress__bar"
      :class="checkColor"
      :style="{
        width:
          +convertPercent(percent) > 100 ? '100' : convertPercent(percent) + '%'
      }"
    >
      <div class="c-fancy-progress__bar-shadow"></div>
    </div>
    <div class="c-fancy-progress__bar-text">
      <slot name="bar-text" />
    </div>
    <div class="c-fancy-progress__text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      type: [Number, String],
      default: 0
    },
    total: {
      type: [Number, String],
      default: 100
    }
  },
  methods: {
    convertPercent(percent) {
      return Number(percent) * this.calcOnePercent;
    }
  },
  computed: {
    calcOnePercent() {
      let propTotal = this.total;
      return 100 / Number(propTotal);
    },
    checkColor () {
      if (
        this.convertPercent(this.percent) > 25 &&
        this.convertPercent(this.percent) < 50
      ) {
        return "c-fancy-progress__bar--green";
      } else if (
        this.convertPercent(this.percent) >= 50 &&
        this.convertPercent(this.percent) < 75
      ) {
        return "c-fancy-progress__bar--yellow";
      } else if (this.convertPercent(this.percent) >= 75) {
        return "c-fancy-progress__bar--orange";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$red: #ea5d63;
$orange: #d73f15;
$yellow: #f3ac00;
$green: #00b217;

@mixin innerColor($color: $red) {
  background: $color;
}

.c-fancy-progress {
  font-size: 1.2em;
  height: 20px;
  background: rgba(255, 255, 255, 0);
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
  position: relative;
  &--active .progress__bar {
    opacity: 1;
  }
  &__bar {
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    line-height: 19px;
    display: block;
    position: relative;
    top: 0px;
    bottom: 0px;
    left: 0px;
    width: 0%;
    height: 100%;
    border-radius: 2px 0 0 2px;
    transition: all 1s ease;
    background: #5d8eea;
    .c-fancy-progress__bar-shadow {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      overflow: hidden;
      &:before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.1) 49%,
          rgba(0, 0, 0, 0) 100%
        );
      }
      &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        width: 20%;
        z-index: 3;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.2) 49%,
          rgba(255, 255, 255, 0) 100%
        );
        transition: all 0.3s ease;
        animation: pulse 1.5s ease-out infinite;
      }
    }
    &:before,
    &:after {
      content: "";
      position: absolute;
      right: -1px;
      top: -5px;
      width: 1px;
      height: 30px;
    }
    &:before {
      width: 7px;
      right: -4px;
      background: radial-gradient(
        ellipse at center,
        rgba(255, 255, 255, 0.4) 0%,
        rgba(255, 255, 255, 0) 75%
      );
    }
    &:after {
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.3) 25%,
        rgba(255, 255, 255, 0.3) 75%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
}
.c-fancy-progress__bar-text {
  position: absolute;
  line-height: 16px;
  right: 10px;
  left: 10px;
  top: 1px;
  color: #fff;
  font-size: 12px;
  em {
    font-style: normal;
  }
}

@keyframes pulse {
  0% {
    left: -50%;
  }
  100% {
    left: 150%;
  }
}
</style>
